import React from 'react';
import { XIcon } from 'lucide-react';
import { PAIN_BODY, PAIN_CLOSING, PAIN_EMPHASIS, PAIN_HEADLINE, painLines } from '../data/eatWellContent';
export function PainSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="pain-title" data-id="element-174" data-mp="2uyoxfwo8um32">
      <div className="mx-auto max-w-5xl px-5" data-id="element-175" data-mp="2yypk24lhy3l7">
        <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-176" data-mp="2z1tsje5zvlho">
          The problem
        </p>
        <h2 id="pain-title" className="mt-3 max-w-3xl font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-177" data-mp="2pyss9u3t8olx">
          {PAIN_HEADLINE}
        </h2>

        {PAIN_BODY.map(line => <p key={line} className="mt-4 max-w-2xl text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-178" data-mp="2g9ix25do6ptl">
            {line}
          </p>)}

        <p className="mt-4 max-w-2xl text-[14px] leading-relaxed text-ivory-100 sm:text-[15px]" data-id="element-179" data-mp="2781l8z7apaap">
          {PAIN_EMPHASIS}
        </p>

        <ul className="mt-8 grid gap-x-10 border-t border-charcoal-600 sm:grid-cols-2" data-id="element-180" data-mp="3rovdeuroee95">
          {painLines.map(line => <li key={line} className="flex items-start gap-3 border-b border-charcoal-600 py-4" data-id="element-181" data-mp="5gc9c7263psv">
              <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-rose-deep" strokeWidth={3} aria-hidden="true" data-id="element-182" data-mp="h98yzx4u7r8" />
              <span className="text-[14px] font-medium leading-snug text-ivory-100" data-id="element-183" data-mp="33yhjsztg07cg">
                {line}
              </span>
            </li>)}
        </ul>

        <p className="mt-8 max-w-2xl font-display text-lg italic leading-snug text-champagne sm:text-2xl" data-id="element-184" data-mp="3dvvzuybgeu48">
          {PAIN_CLOSING}
        </p>
      </div>
    </section>;
}